if (typeof process === 'undefined') {
    window.process = { env: {} };
}

const TMDB_TOKEN = process.env.PARCEL_TMDB_TOKEN || import.meta.env?.PARCEL_TMDB_TOKEN;
console.log("All available env vars:", process.env);

// import 'dotenv/config';
// const TMDB_TOKEN = process.env.THEMOVIEDB_BEARER_TOKEN;

//Base URLS
const image_url = 'https://image.tmdb.org/t/p';
const poster_baseURL = `${image_url}/w300`; //consider other widths
const backdrop_baseURL = `${image_url}/original`;
const vidscr_baseURL = 'https://vidsrc.net/embed/';
const searchModalBtn = document.getElementById('search_modal_btn');
const closeSearchModal = document.getElementById('close_modal_btn');
const searchResultsContainer = document.getElementById('search_results_container');
const homePage = document.getElementById('home_page');
const playPage = document.getElementById('play_page');
const backHome = document.getElementById("back_home");
const videoContainer = document.getElementById('video_player');
const creditsContainer = document.getElementById('results');
let slideIndex = 0;

const options = {
	method: 'GET',
	headers: {
		accept: 'application/json',
		Authorization: `Bearer ${TMDB_TOKEN}`,
	},
};


window.addEventListener('scroll', () => {
	const header = document.querySelector('.header');

	if (window.scrollY > 50) {
		header.classList.add('scrolled');
	} else {
		header.classList.remove('scrolled');
	}
})


// show homepage or  play page as the user interacts 

backHome.addEventListener('click', () => {
    homePage.style.display = "block";
    playPage.style.display = "none";
    videoContainer.innerHTML = ''
  
});


//first call to get content
const getContentInfo = async function (url, type) {
	const response = await fetch(url, options);
	const data = await response.json();
	// console.log(data.results);
	return data.results.map(el => {
		return {
			type: type,
			title: type === 'movie' ? el.original_title : el.name,
			poster: `${poster_baseURL}${el.poster_path}`,
			rating: `${Math.round(el.vote_average)}/10`,
			id: el.id,
			backdrop: `${backdrop_baseURL}${el.backdrop_path}`,
			poplarity: el.popularity,
			vote_average: el.vote_average,
			date: type === 'TV' ? el.first_air_date : el.release_date
		};
	});
};

//call to get details 
const getContentDetails = async function (id, type) {
	try {
		if (type === 'movie') {
			const details = await getMovieDetails(id);
			const credits = await getMovieCredits(id);
			const similar = await getSimilarMovies(id);
			return {
				type: type,
				title: details.title,
				genres: details.genre_names,
				release_date: details.release_date,
				rating: `${Math.round(details.vote_average)}/10`,
				overview: details.overview,
				credits: credits.cast.slice(0, 5).map(actor => ({
					actor: actor.name,
					image: `${poster_baseURL}${actor.profile_path}`
				})),
				poster: `${poster_baseURL}${details.poster_path}`,
				backdrop: `${backdrop_baseURL}${details.backdrop_path}`,
				imdb_id: details.imdb_id,
				id: details.id,
				original_language: details.original_language,
				runtime: `${details.runtime} mins`,
				similar: similar.map(sim => sim.title),
				production: details.production_companies,
				country: details.production_countries,
				vidSrc: `${vidscr_baseURL}${details.imdb_id}`
			};
		}
		if (type === 'TV') {
			const details = await getTvDetails(id);
			const credits = await getTvCredits(id);
			// Fetch season details with episode data
			const season_details = await Promise.all(details.seasons.map(async (season) => {
				const seasonData = await getTvSeasonDetails(id, season.season_number);
				return {
					season_number: season.season_number,
					episodes: seasonData.episodes.map(ep => ({
						ep_air_date: ep.air_date,
						ep_name: ep.name,
						ep: ep.episode_number,
						ep_source: `${vidscr_baseURL}tv/${id}/${season.season_number}/${ep.episode_number}`
					}))
				};
			}));
			return {
				type,
				title: details.name,
				genres: details.genres.map(genre => genre.name),
				original_air_date: details.first_air_date,
				rating: `${Math.round(details.vote_average)}/10`,
				overview: details.overview,
				credits: credits.cast.slice(0, 5).map(actor => ({
					actor: actor.name,
					image: `${poster_baseURL}${actor.profile_path}`
				})),
				poster: `${poster_baseURL}${details.poster_path}`,
				backdrop: `${backdrop_baseURL}${details.backdrop_path}`,
				imdb_id: details.external_ids?.imdb_id || 'N/A',
				id: details.id,
				original_language: details.original_language,
				seasons: details.seasons.map(season => ({
					season_number: season.season_number,
					episodes: season.episode_count,
					poster: `${backdrop_baseURL}${season.poster_path}`,
				})),
				production: details.production_companies.map(el => el.name),
				country: details.origin_country,
				episode_details: season_details,  // Now includes full episode info
			};
		}
	} catch (error) {
		console.log(error);
		return [];

	}
};

/*************************************************************************************************************************************************************** */
//Helper Functions

const getTvSeasonDetails = async (tvId, seasonNumber) => {
	try {
		const response = await fetch(`https://api.themoviedb.org/3/tv/${tvId}/season/${seasonNumber}`, options);
		if (!response.ok) {
			throw new Error(`Failed to fetch season details for TV ID: ${tvId}, Season: ${seasonNumber}`);
		}

		return await response.json();
	} catch (error) {
		console.error(`Error fetching season details:`, error);
		return { episodes: [] }; // Return empty episodes in case of failure
	}
};
const fetchTMDBData = async (url) => {
	try {
		const response = await fetch(url, options);
		if (!response.ok) throw new Error(`Failed to fetch: ${url}`);
		return await response.json();
	} catch (error) {
		console.error(error);
		return null;
	}
};
const getMovieDetails = async (tmdbId) => {
	const url = `https://api.themoviedb.org/3/movie/${tmdbId}?language=en-US`;
	const data = await fetchTMDBData(url);
	return data ? {
		imdb_id: data.imdb_id,
		genre_names: data.genres.map(el => el.name),
		runtime: data.runtime,
		production_companies: data.production_companies.map(el => el.name),
		production_countries: data.production_countries.map(el => el.iso_3166_1),
		title: data.title,
		id: data.id,
		original_language: data.original_language,
		overview: data.overview,
		release_date: data.release_date,
		backdrop_path: data.backdrop_path,
		vote_average: data.vote_average,
	} : {};
};
const getMovieCredits = async (tmdbId) => {
	const url = `https://api.themoviedb.org/3/movie/${tmdbId}/credits?language=en-US`;
	return await fetchTMDBData(url) || { cast: [] };
};
const getSimilarMovies = async (tmdbId) => {
	const url = `https://api.themoviedb.org/3/movie/${tmdbId}/similar?language=en-US&page=1`;
	return (await fetchTMDBData(url))?.results || [];
};
const getTvDetails = async (tmdbId) => {
	const url = `https://api.themoviedb.org/3/tv/${tmdbId}?language=en-US`;
	return await fetchTMDBData(url) || {};
};
const getTvCredits = async (tmdbId) => {
	const url = `https://api.themoviedb.org/3/tv/${tmdbId}/credits?language=en-US`;
	return await fetchTMDBData(url) || { cast: [] };
};

/*************************************************************************************************************************************************************** */
// Search Functionality

const searchTerm = document.getElementById('search-term');

const addSearchParam = function (link, keyword) {
	keyword = keyword.replaceAll(/ /g, '%'); // replace any spaces in keyword with % - more efficent
	link = link.replace(
		`${link.substring(link.indexOf('q'), link.indexOf('&'))}`,
		`query=${keyword}` //replace anything that comes between q and & with query=${keyword}
	);
	return link;
};
const searchMedia = async function (keyword) {
	try {
		const movies = await getContentInfo(addSearchParam(`https://api.themoviedb.org/3/search/movie?query=&include_adult=false&language=en-US&page=1`, keyword), 'movie');
		const tv = await getContentInfo(addSearchParam(`https://api.themoviedb.org/3/search/tv?query=&include_adult=false&language=en-US&page=1`, keyword), 'TV');
		const results = await Promise.all(
			[...movies.sort((a, b) => b.date - a.date).filter((el, i) => i < 7), ...tv.sort((a, b) => b.date - a.date).filter((el, i) => i < 7)]
		);
		const sorted = results.map(el => el).sort((a, b) => b.vote_average - a.vote_average);
		return sorted.sort((a, b) => b.poplarity - a.poplarity).filter((el, i) => i < 7); // if number of keyword is less than 5 don't get anything from origin east - JP, KR
	} catch (error) {
		console.error(error);
		return [];
	}
};

const debounce = function (callback, delay) {
	let timer = null;
	return function (...args) {
		if (timer) clearTimeout(timer);
		timer = setTimeout(function () {
			callback(...args);
		}, delay);
	};
};


const debouncedSearch = debounce(e => {
	const searchTermHTML = document.getElementById('search_results');
	searchTermHTML.innerHTML = '';

	searchMedia(e.target.value).then(res => {
        res.forEach(el => { 
            const movieCard = document.createElement('div');
            movieCard.classList.add('movie-card');
            movieCard.innerHTML = `
                 <img src="${el.poster}" alt="${el.title} poster">
                    <div class="movie-info">
                        <span class="movie-title">${el.title}</span>
                        <div class="movie-details">.
                            <span class="type">${el.type}</span>
                            <div class="rating">
                                <span>${el.rating}</span>
                            </div>
                        </div>
                    </div>
            `;

			// Add click event listener to each movie card
			movieCard.addEventListener('click', async () => {
                const details = await getContentDetails(el.id, el.type);
                if (el.type === 'movie') {
                renderMovie(details)
                } else if (el.type === 'TV') {
                    renderTv(details);
                }
                renderCredits(details);
                homePage.style.display = "none"
                playPage.style.display = "block"
	
			});

			searchTermHTML.appendChild(movieCard); // Append the created element
		});
	});     // renderSearch
}, 500);


if (searchTerm) {
	searchTerm.addEventListener('input', debouncedSearch);
} else {
	alert(`Movie/ TV show not found`);
}


searchModalBtn.addEventListener('click', () => {
	searchResultsContainer.style.display = "block";
	searchTerm.focus();

});

closeSearchModal.addEventListener('click', () => {
	searchResultsContainer.style.display = "none";
});




/*************************************************************************************************************************************************************** */


// Generic movie tile can be called to render in any container e.g. Popular movies, TOP movies, TOP TV, search results et al
const renderResults = function (el, string) {
	const tile = ` <div class="movie-card" id="${el.id}" data-type="${el.type}">
                    <img src="${el.poster}" alt="${el.title} poster">
                    <div class="movie-info">
                        <span class="movie-title">${el.title}</span>
                        <div class="movie-details">
                            <span class="type">${el.type}</span>
                            <div class="rating">
                                <span>${el.rating}</span>
                            </div>
                        </div>
                    </div>
                </div>`;
	const container = document.getElementById(string);
	container.insertAdjacentHTML('beforeend', tile);
};

const topRatedMovies = getContentInfo('https://api.themoviedb.org/3/movie/top_rated?language=en-US&page=1', 'movie').then(data => {
	// console.log(data);
	data.forEach(el => {
		renderResults(el, 'topRatedMovies');

	});
});

const topMovies = getContentInfo('https://api.themoviedb.org/3/movie/popular?language=en-US&page=1', 'movie').then(data => {
	data.forEach(el => {
		renderResults(el, 'popular');

	});
});


const popularTvSeries = getContentInfo('https://api.themoviedb.org/3/tv/popular?language=en-US&page=1', 'TV').then(data => {
	data.forEach(el => {

		renderResults(el, "popularTvSeries");
	});

});



const topTvSeries = getContentInfo('https://api.themoviedb.org/3/tv/top_rated?language=en-US&page=1', 'TV').then(data => {
    data.forEach(el => {
        renderResults(el, 'topRatedSeries');
    }) 
});

// start search here
// search helper functions
//function to add query parameters to a search url

// searchMedia('house').then(data => data);
// searchMedia('house').then(data => console.log(data));

//TODO - replace query selector for search input 
// const searchContainer = document.querySelector('#search-term');

// searchContainer.addEventListener('input', debouncedSearch);





// this function will take in a search result object either from an an array or else and the second param is a container where the results are to be displayed
//




const popularMov = document.getElementById('popular');
const topRatedMov = document.getElementById('topRatedMovies');
const topRatedSeries = document.getElementById('topRatedSeries');
const popularSeries = document.getElementById('popularTvSeries');




//event listener to get details when a user clicks on a tile
// also to be used to render details onto the play page
// handles what happens when a movie or slider card is clicked 
const handleContentClick = async (e) => {
	const id = e.target.parentNode.id;
	const type = e.target.parentNode.dataset.type;
    const movieData = await getContentDetails(id, type);
    homePage.style.display = 'none';
    playPage.style.display = "block";
    console.log(movieData);

    if (movieData.type === 'movie') {
        renderMovie(movieData)
    } else if (movieData.type === 'TV') {
        renderTv(movieData);
    }

    renderCredits(movieData);
};

// renders the credits of movie or tv show clicked
function renderCredits(data) {
        creditsContainer.innerHTML = '';

        data.credits.forEach(credit => {
        const creditDiv = document.createElement('div')
        creditDiv.classList.add('credits_div');
        const imgEl = document.createElement('img');
        imgEl.classList.add('prof_pic');
        imgEl.src = `${credit.image}`;
        const nameEl = document.createElement('p');
        nameEl.classList.add('actor_name');
        nameEl.textContent = credit.actor;

        creditDiv.appendChild(imgEl);
        creditDiv.appendChild(nameEl);
        creditsContainer.appendChild(creditDiv);
    })
}

// renders the movie player and credits
function renderMovie(movie) {
    videoContainer.innerHTML = `
        <iframe class="iframe" allowfullscreen=true frameBorder="0" src="${movie.vidSrc}" width="100%" height="800"></iframe>
        <h2">${movie.title}</h2>
    `;
}


// renders tv shows episodes with seasons and episode and credits
function renderTv(tv) {
        videoContainer.innerHTML = `
        <iframe id="tvPlayer" class="iframe" allowfullscreen=true src="${tv.vidSrc}" width="100%" height="800"></iframe>
        <h2>${tv.title}</h2>
		<div class="controls container">
			<div id="seasonContainer" class="season_container"></div>
			<div id="episodeContainer" class="episodes_container"></div>
		</div>
    `

    const iframe = document.getElementById('tvPlayer');


    const seasonContainer = document.getElementById('seasonContainer');
    seasonContainer.innerHTML = '';

    // tv.episode_details.forEach(season => {
    //     const seasonBtn = document.createElement('button');
    //     seasonBtn.classList.add('season_button');
    //     seasonBtn.textContent = `S0${season.season_number}`;
    //     seasonBtn.addEventListener('click', () => renderEpisodes(season.episodes, iframe));
    //     seasonContainer.appendChild(seasonBtn);
    // })

	const seasonSelect = document.createElement('select');
	seasonSelect.classList.add('season_select');
	seasonContainer.appendChild(seasonSelect);

	tv.episode_details.forEach(season => {
		const option = document.createElement('option');
		option.value = season.season_number;
		option.textContent = `S${season.season_number.toString().padStart(2, '0')}`;
		seasonSelect.appendChild(option);
	});

	seasonSelect.addEventListener('change', () => {
		const selectedSeasonNumber = parseInt(seasonSelect.value);
		const selectedSeason = tv.episode_details.find(season => season.season_number === selectedSeasonNumber);


		if (selectedSeason) {
		renderEpisodes(selectedSeason.episodes, iframe);
	}
	});

	if (tv.episode_details.length > 0) {
    seasonSelect.value = tv.episode_details[0].season_number;
    renderEpisodes(tv.episode_details[0].episodes, iframe);
}
}


//helper funcion that rednders episodes in each season
function renderEpisodes(episodes, iframe) {
    const episodeContainer = document.getElementById('episodeContainer');
    episodeContainer.innerHTML = '';

  
	episodes.forEach(episode => {
		const epKey = `watched_S${episode.ep_name.toString().padStart(2, '0')}`;
		const epDiv = document.createElement('div');
		
		epDiv.classList.add('episode');

		if (localStorage.getItem(epKey)) {
			epDiv.classList.add('watched');
		}

		epDiv.textContent = `Episode ${episode.ep}: ${episode.ep_name}`;

		epDiv.addEventListener('click', () => {
			iframe.src = episode.ep_source;

			localStorage.setItem(epKey, true);
			epDiv.classList.add('watched');
		});

		episodeContainer.appendChild(epDiv);
	});

	if (episodes.length > 0) {
        iframe.src = episodes[0].ep_source;
    }
}

popularMov.addEventListener('click', handleContentClick);
topRatedMov.addEventListener('click', handleContentClick);
topRatedSeries.addEventListener('click', handleContentClick);
popularSeries.addEventListener('click', handleContentClick);


// home carousel section
// const showSlides = () => {
// 	const slides = document.querySelectorAll('#slider .slider');

// 	for (let i = 0; i < slides.length; i++) {
// 		slides[i].style.display = "none";
// 	}
// 	slideIndex++;

// 	if (slideIndex > slides.length) { slideIndex = 1; }
// 	slides[slideIndex - 1].style.display = "block";

// 	setTimeout(showSlides, 7000);
// };


const getCarouselData = async function () {
	try {
		const movies = await getContentInfo('https://api.themoviedb.org/3/movie/now_playing?language=en-US&page=1', 'movie');
		const tv = await getContentInfo('https://api.themoviedb.org/3/tv/airing_today?language=en-US&page=1', 'TV');

		const results = await Promise.all([...movies, ...tv]);
		return results;

	} catch (error) {
		console.error(error);
		return [];

	}


};

getCarouselData().then(data => {
	data.sort((a, b) => b.poplarity - a.poplarity);
	const sliderContainer = document.getElementById("slider");

	sliderContainer.innerHTML = "";

	data.forEach(slide => {
		const slideItem = document.createElement('div');
		slideItem.classList.add('swiper-slide');
		slideItem.innerHTML = `
                    <img src="${slide.backdrop}" alt="movie/series backrop">
                    <div class="content">
                        <h2>${slide.title}</h2>
                        <p>- ${slide.rating} -</p>  
                    </div>
        `;
        slideItem.addEventListener('click', async () => {
            const details = await getContentDetails(slide.id, slide.type);
            if (slide.type === 'movie') {
                renderMovie(details)
            } else if (slide.type === 'TV') {
                renderTv(details);
            }
            renderCredits(details);
            homePage.style.display = "none";
            playPage.style.display = "block";
          
            console.log(details.title);
        });

		sliderContainer.appendChild(slideItem);
	});

	// showSlides();
});

const swiper = new Swiper('.swiper', {
  // Optional parameters
  direction: 'horizontal',
//   loop: true,
  autoplay: {
        delay: 7000,
        disableOnInteraction: false,
    },

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
	clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});